export const facialRecognition = {
  'All right!': 'Tudo certo!',
  'We’ve confirmed your identity! You can keep enjoying a hair-free life with us!':
    'Confirmamos sua identidade! Você pode continuar a aproveitar uma vida livre de pelos conosco!',
  'Hi, {{name}}!': 'Olá, {{name}}!',
  'We identified {{count}} absence(s)/cancellation(s) with less than 24h notice in your last {{analyzed}} appointments (limit: {{limit}}).':
    'Identificamos {{count}} falta(s)/cancelamento(s) com menos de 24h nos seus últimos {{analyzed}} agendamentos (limite: {{limit}}).',
  'To keep scheduling with us, we need to confirm your identity through facial recognition. It only takes a few seconds.':
    'Para continuar agendando conosco, precisamos confirmar sua identidade através do reconhecimento facial. Leva só alguns segundos.',
  Continue: 'Prosseguir',
};
